import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { Mail, User } from 'lucide-react';
import Button from '../../../../components/common/Button';
import Alert from '../../../../components/common/Alert';

const VALIDATION_RULES = {
  email: {
    required: 'Email is required',
    pattern: {
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: 'Please enter a valid email address'
    }
  },
  name: {
    required: 'Full name is required',
    minLength: {
      value: 2,
      message: 'Name must be at least 2 characters'
    }
  }
};

export default function AdminSetup({ onComplete, initialData = {}, companyDomain }) {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: initialData
  });


  return (
    <form onSubmit={handleSubmit(onComplete)} className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-navy mb-1">
          Admin Email
        </label>
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-navy/40 w-5 h-5" />
          <input
            type="email"
            {...register('email', {
              required: 'Email is required',
              pattern: {
                value: new RegExp(`@${companyDomain}$`),
                message: `Email must end with @${companyDomain}`
              }
            })}
            className="w-full pl-10 pr-4 py-2 rounded-lg border-2 border-light-purple focus:border-primary focus:ring focus:ring-primary/20 transition-colors"
            placeholder={`admin@${companyDomain}`}
          />
        </div>
        {errors.email && (
          <span className="text-sm text-error mt-1">{errors.email.message}</span>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-navy mb-1">
          Full Name
        </label>
        <div className="relative">
          <User className="absolute left-3 top-1/2 -translate-y-1/2 text-navy/40 w-5 h-5" />
          <input
            type="text"
            {...register('name', { required: 'Full name is required' })}
            className="w-full pl-10 pr-4 py-2 rounded-lg border-2 border-light-purple focus:border-primary focus:ring focus:ring-primary/20 transition-colors"
            placeholder="John Doe"
          />
        </div>
        {errors.name && (
          <span className="text-sm text-error mt-1">{errors.name.message}</span>
        )}
      </div>

      <Alert type="info">
        The admin account will have full control over your company's Stickr settings and user management.
      </Alert>

      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={() => window.history.back()}>
          Back
        </Button>
        <Button type="submit">Continue</Button>
      </div>
    </form>
  );
}